import EditableItem from '@/components/editors/EditableItem.vue'

export default{
  components: {
    EditableItem
  },
  data() {
    return {
      editableLoaded: false
    }
  },
  created () {
    this.editableLoad()
  },
  methods: {
    async editableLoad () {
      this.$k.fetchStories(this.$route.name, () => {
        this.editableLoaded = true
      })
    }
  },
  watch: {
    '$route.path': function () {
      this.editableLoad()
    }
  }
}